import { gql } from '@apollo/client'

export const UPDATE_BROADSIGN_CREATION = gql`
  mutation UpdateBroadsignCreation(
    $id: ID!
    $commercialSupervisorId: ID
    $departmentId: ID
    $advertiserId: ID
  ) {
    updateBroadsignCreation(
      input: {
        id: $id
        commercialSupervisorId: $commercialSupervisorId
        departmentId: $departmentId
        advertiserId: $advertiserId
      }
    ) {
      broadsignCreation {
        id
        commercialSupervisor {
          id
        }
        department {
          id
        }
        advertiser {
          id
        }
      }
      errors
    }
  }
`
